module.exports = "/assets/packs/images/e8b8c59fa32b32cb2d9a811be04a01cb.png";